import React, { type ComponentProps, type FC } from 'react';
import { RendererFactory, Serializer } from 'survey-core';
import { ReactQuestionFactory } from 'survey-react-ui';

import { bootIsInformationAccurateQuestion } from './questions/isInformationAccurateQuestion';
import { bootPhoneNumberVerificationQuestion } from './questions/phoneNumberVerificationQuestion';
import { bootPhotoUploadQuestion } from './questions/photoUploadQuestion';
import { bootPreviousFormulaQuestion } from './questions/previousFormulaQuestion';
import CheckboxQuestion from '../components/checkboxQuestion';
import ImagePicker from '../components/imagePicker';
import RadioGroup from '../components/radioGroup';
import Text from '../components/text';

let booted = false;

const addCustomProperties = () => {
  Serializer.addProperty('survey', {
    name: 'group',
  });

  Serializer.addProperty('survey', {
    name: 'version',
    type: 'number',
  });

  Serializer.addProperty('survey', {
    name: 'autoAdvanceDelay',
    type: 'number',
  });

  Serializer.addProperty('question', {
    name: 'semanticMeaning',
    type: 'multiplevalues',
  });

  Serializer.addProperty('question', {
    name: 'hideNavigation',
    type: 'boolean',
  });

  Serializer.addProperty('panel', {
    name: 'hideBackNavigation',
    type: 'boolean',
  });

  Serializer.addProperty('question', {
    name: 'hideBackNavigation',
    type: 'boolean',
  });

  Serializer.addProperty('question', {
    name: 'photoData',
  });

  Serializer.addProperty('question', {
    name: 'ctaButtonText',
  });

  Serializer.addProperty('question', {
    name: 'content',
  });

  Serializer.addProperty('question', {
    name: 'descriptionOrientation',
    type: 'multiplevalues',
  });

  Serializer.addProperty('question', {
    name: 'descriptionImage',
    type: 'string',
  });

  Serializer.addProperty('question', {
    name: 'optionOrientation',
    type: 'string',
  });

  Serializer.addProperty('question', {
    name: 'iconSize',
    type: 'number',
  });

  Serializer.addProperty('question', {
    name: 'titleHighlight',
    type: 'string',
  });

  Serializer.addProperty('question', {
    name: 'phoneVerificationTitle',
    type: 'string',
  });

  Serializer.addProperty('question', {
    name: 'disclaimer',
    type: 'string',
  });

  Serializer.addProperty('question', {
    name: 'categories',
  });

  Serializer.addProperty('itemvalue', {
    name: 'inputIcon',
  });

  Serializer.addProperty('itemvalue', {
    name: 'inputIcon2',
  });

  Serializer.addProperty('itemvalue', {
    name: 'description',
  });

  Serializer.addProperty('itemvalue', {
    name: 'selectionText',
  });

  Serializer.addProperty('itemvalue', {
    name: 'clearOtherValues',
  });

  Serializer.addProperty('itemvalue', {
    name: 'category',
  });

  Serializer.addProperty('itemvalue', {
    name: 'component',
  });

  Serializer.addProperty('itemvalue', {
    name: 'orderBelowAge35',
  });

  Serializer.addProperty('itemvalue', {
    name: 'orderAboveAge35',
  });

  Serializer.addProperty('itemvalue', {
    name: 'imageLink',
  });
};

const registerInputs = () => {
  ReactQuestionFactory.Instance.registerQuestion(
    'sv-cur-input-text',
    (props) => {
      return React.createElement<ComponentProps<any>>(Text as FC, props);
    },
  );

  RendererFactory.Instance.registerRenderer(
    'text',
    'cur-input-text',
    'sv-cur-input-text',
  );

  ReactQuestionFactory.Instance.registerQuestion(
    'sv-cur-input-checkbox',
    (props) => {
      return React.createElement<ComponentProps<any>>(
        CheckboxQuestion as FC,
        props,
      );
    },
  );

  RendererFactory.Instance.registerRenderer(
    'checkbox',
    'cur-input-checkbox',
    'sv-cur-input-checkbox',
  );

  ReactQuestionFactory.Instance.registerQuestion(
    'sv-cur-input-radiogroup',
    (props) => {
      return React.createElement<ComponentProps<any>>(RadioGroup as FC, props);
    },
  );

  RendererFactory.Instance.registerRenderer(
    'radiogroup',
    'cur-input-radiogroup',
    'sv-cur-input-radiogroup',
  );

  ReactQuestionFactory.Instance.registerQuestion(
    'sv-cur-input-imagepicker',
    (props) => {
      return React.createElement<ComponentProps<any>>(ImagePicker as FC, props);
    },
  );

  RendererFactory.Instance.registerRenderer(
    'imagepicker',
    'cur-input-imagepicker',
    'sv-cur-input-imagepicker',
  );
};
const boot = () => {
  if (booted) {
    return;
  }

  addCustomProperties();
  registerInputs();
  bootPhotoUploadQuestion();
  bootPhoneNumberVerificationQuestion();
  bootPreviousFormulaQuestion();
  bootIsInformationAccurateQuestion();
  booted = true;
};

export {
  /**
   * Bootstrap the SurveyJS core library with customizations and utilities.
   * This is required before calling any additional utilities such as `makeSurvey`.
   */
  boot,
};
